import React from 'react';
import CuentaForm from './CuentaForm';

export default function DatosPersonales() {
  return <CuentaForm title="Datos Personales" />;
}
